import Widget from "./base.js";
import { getCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

export class PostArticleAsk extends Widget {
	componentWillMount() {
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;

		// this component gets different text depending on whether the user was a member in the past
		const profileData = this.getProfileData();

		const self = this;
		function initializeState(profile) {
			if (profile.membership_was) self.setState({ membership_was: true });
		}

		if (typeof profileData.then === "function") {
			// promise
			profileData.then((resp) => {
				initializeState(resp);
			});
		} else {
			//not a promise
			initializeState(profileData);
		}
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		return getProfile();
	}

	href(product) {
		if (this.state.membership_was) return this.comebackHref;
		if (product.length === 0) product = "prime-annual";

		const source = "on_site";
		const campaign = "memberships";
		const medium = "widget_article";

		return `${document.location.origin}/memberships/${product}?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}`;
	}

	comebackHref() {
		const source = "on_site";
		const campaign = "memberships";
		const medium = "return-widget_article";
		const promo = "&promo=40OffAny";

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}${promo}`;
	}

	renderContent() {
		if (this.state.dismissed) return;

		return (
			<div>
				<div className="PostArticleAsk__Heading">
					Original Reporting. Smart, Non-Hysterical Analysis.
				</div>
				<div className="PostArticleAsk__Text">
					<div>
						After our recent membership drive, we spoke with dozens of new
						members about why they decided to join TPM. Over and over again we
						heard the same refrain: “You’re just what i’ve been looking for –
						smart, non-hysterical analysis. And you do original reporting!”
					</div>

					<div>
						In a crowded news environment, we’re glad readers are noticing what
						makes TPM different. One simple reason that we are able to avoid the
						cheap-click hysteria and invest in original reporting is that our
						business model is 100% about the journalism. Memberships and reader
						support now make up 90% of our revenue, meaning{" "}
						<b>
							our readers help us determine what’s valuable, and not the ad
							markets
						</b>
						. However, it also means the business model doesn’t work without
						regular readers becoming members.
					</div>

					<div>
						So if you enjoy TPM, the best way to support us is by becoming a
						member.
					</div>
				</div>
				<div className="PostArticleAsk__Pitch">
					<div className="PostArticleAsk__PitchText">
						{this.state.membership_was
							? "Rejoin now and get 40% off any TPM membership"
							: "Become a Prime member for just"}
					</div>
					{this.state.membership_was && (
						<div className="PostArticleAsk__Buttons">
							<a href={this.comebackHref()} className="Button --white-red">
								Rejoin for 40% Off
							</a>
						</div>
					)}
					{!this.state.membership_was && (
						<div className="PostArticleAsk__Buttons">
							<a
								href={this.href("prime-monthly")}
								className="Button --white-red"
							>
								$5.99/month
							</a>
							<a
								href={this.href("prime-annual")}
								className="Button --white-red"
							>
								$60/year
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}
}
